var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleAuthenticatorIcn = function SvgGoogleAuthenticatorIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-authenticator-icn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.001 48.002c13.255 0 24-10.746 24-24.001S37.257 0 24.002 0 0 10.746 0 24.001s10.746 24 24.001 24Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.001 39.274c-8.436 0-15.273-6.837-15.273-15.273S15.565 8.728 24.001 8.728a15.23 15.23 0 0 1 10.8 4.473l6.17-6.17A23.927 23.927 0 0 0 24.002 0C10.745 0 0 10.745 0 24.001c0 13.256 10.745 24 24.001 24a23.938 23.938 0 0 0 16.973-7.027l-6.172-6.172a15.246 15.246 0 0 1-10.801 4.472Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.273 24.005h-7.637A7.639 7.639 0 0 0 24 16.367a7.636 7.636 0 0 0-5.502 12.929l-.006.006 9.455 9.455.002.002c6.521-1.74 11.325-7.686 11.325-14.754Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.001 24h-8.728c0 7.069-4.806 13.014-11.324 14.755l6.74 6.74C42.58 41.563 48.001 33.415 48.001 24Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.001 47.73c-13.21 0-23.924-10.671-24-23.863L0 24.004C0 37.26 10.745 48.005 24.001 48.005c13.256 0 24-10.745 24-24L48 23.866c-.075 13.192-10.792 23.864-23.999 23.864Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.951 38.755.213.212c6.41-1.81 11.11-7.701 11.11-14.694V24c0 7.069-4.805 13.014-11.323 14.755Z",
    fill: "#fff",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.638 21.82H24a2.181 2.181 0 1 0 0 4.363h19.636a2.182 2.182 0 0 0 .002-4.363Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.638 21.82H24a2.181 2.181 0 1 0 0 4.363h19.636a2.182 2.182 0 0 0 .002-4.363Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.363 25.64a1.636 1.636 0 1 0 0-3.273 1.636 1.636 0 0 0 0 3.273ZM24.001 5.999a1.636 1.636 0 1 0 0-3.273 1.636 1.636 0 0 0 0 3.273ZM24.001 45.272a1.636 1.636 0 1 0 0-3.272 1.636 1.636 0 0 0 0 3.272ZM10.091 11.749a1.636 1.636 0 1 0 0-3.272 1.636 1.636 0 0 0 0 3.272ZM10.091 39.546a1.636 1.636 0 1 0 0-3.273 1.636 1.636 0 0 0 0 3.273Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.91 39.546a1.636 1.636 0 1 0 0-3.273 1.636 1.636 0 0 0 0 3.273Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.002 22.093h19.636c1.158 0 2.106.905 2.174 2.046.002-.046.007-.09.007-.137a2.182 2.182 0 0 0-2.181-2.182H24.002a2.182 2.182 0 0 0-2.182 2.182c0 .046.002.09.008.137a2.177 2.177 0 0 1 2.174-2.046Z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.812 24.133a2.183 2.183 0 0 1-2.174 2.046H24.002a2.178 2.178 0 0 1-2.174-2.046 1.08 1.08 0 0 0-.008.135c0 1.205.977 2.182 2.182 2.182h19.636a2.181 2.181 0 0 0 2.181-2.182 1.08 1.08 0 0 0-.007-.135Z",
    fill: "#212121",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.001 9.004c4.216 0 8.034 1.71 10.8 4.473l6.305-6.308-.136-.138-6.17 6.172a15.231 15.231 0 0 0-10.799-4.474c-8.436 0-15.272 6.837-15.272 15.273l.001.137c.074-8.372 6.882-15.135 15.271-15.135Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.001 48.002c13.255 0 24-10.746 24-24.001S37.257 0 24.002 0 0 10.746 0 24.001s10.746 24 24.001 24Z",
    fill: "url(#google-authenticator-icn_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "google-authenticator-icn_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.038 6.984) scale(47.919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google-authenticator-icn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgGoogleAuthenticatorIcn;